import { Box, Button, Flex, Heading, Text, UseModalProps } from '@chakra-ui/react';
import { Modal } from '@sphere/ui';
import useTranslation from 'next-translate/useTranslation';

type Props = UseModalProps & {
  title: string;
  message?: string;
  confirmationText?: string;
  onConfirmed?: (confirmed: boolean) => void;
};

export const ConfirmationModal = ({
  isOpen,
  onClose,
  title,
  message,
  confirmationText = 'Continue',
  onConfirmed = () => void 0,
}: Props) => {
  const { t } = useTranslation('common');
  return (
    <Modal testId="confirmation-modal" isOpen={isOpen} onClose={onClose} padding={0}>
      <Box p={{ base: 'space.24', md: 'space.32' }}>
        <Heading size="lg">{title}</Heading>

        <Text fontSize="lg" mt="space.16">
          {message}
        </Text>

        <Flex mt="space.24" gap="space.8">
          <Button
            onClick={() => {
              onConfirmed(true);
              onClose();
            }}
          >
            {' '}
            {confirmationText}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              onConfirmed(false);
              onClose();
            }}
          >
            {t('cancel')}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};
